'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardCredentialCount(kind, used, registered) {
  this.tQ = null;
  this.xf = 0;
  this.xe = 0;
  this.tQ = kind;
  this.xf = used;
  this.xe = registered;
}
export { $c_Lpresto_types$DashboardCredentialCount as $c_Lpresto_types$DashboardCredentialCount };
$p = $c_Lpresto_types$DashboardCredentialCount.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardCredentialCount;
/** @constructor */
function $h_Lpresto_types$DashboardCredentialCount() {
}
export { $h_Lpresto_types$DashboardCredentialCount as $h_Lpresto_types$DashboardCredentialCount };
$h_Lpresto_types$DashboardCredentialCount.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("DashboardCredentialCount"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.tQ));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.xf);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.xe);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 3);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$DashboardCredentialCount)) {
    if (((this.xf === x$0.xf) && (this.xe === x$0.xe))) {
      var x = this.tQ;
      var x$2 = x$0.tQ;
      return (x === x$2);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "DashboardCredentialCount";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.tQ;
      break;
    }
    case 1: {
      return this.xf;
      break;
    }
    case 2: {
      return this.xe;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$DashboardCredentialCount(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jF)));
}
export { $isArrayOf_Lpresto_types$DashboardCredentialCount as $isArrayOf_Lpresto_types$DashboardCredentialCount };
var $d_Lpresto_types$DashboardCredentialCount = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardCredentialCount, "presto.types$DashboardCredentialCount", ({
  jF: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$DashboardCredentialCount as $d_Lpresto_types$DashboardCredentialCount };
//# sourceMappingURL=presto.types$-Dashboard-Credential-Count.js.map
